// 频道与全站基础信息（示例数据）

export interface Channel {
  slug: string;
  name: string;
  label: string;
  tagline: string;
  description: string;
  image: string;
  accent: "primary" | "accent" | "secondary";
  icon: string;
}

export const channels: Channel[] = [
  {
    slug: "entertainment",
    name: "娱乐前线",
    label: "娱乐",
    tagline: "吃瓜第一现场",
    description:
      "聚焦综艺、影视、歌手与娱乐圈新鲜事，围观台前幕后的争议与反转，汇总观众的第一手态度。",
    icon: "ri-movie-2-line",
    accent: "primary",
    image:
      "https://readdy.ai/api/search-image?query=playful%20entertainment%20editorial%20collage%20with%20film%20clapperboard%20popcorn%20and%20speech%20bubbles%2C%20warm%20cream%20background%2C%20coral%20orange%20and%20ink%20tones%2C%20flat%20illustration%20style%2C%20modern%20minimal%20magazine%20art%2C%20soft%20shadows%2C%20cheerful%20atmosphere&width=1200&height=640&seq=cg-channel-ent&orientation=landscape",
  },
  {
    slug: "tech",
    name: "科技风向",
    label: "科技",
    tagline: "围观前沿动态",
    description:
      "手机、AI、数码圈新品与行业论战，看看技术从业者和普通用户究竟怎么选、怎么吵。",
    icon: "ri-cpu-line",
    accent: "accent",
    image:
      "https://readdy.ai/api/search-image?query=modern%20minimalist%20technology%20collage%20with%20smartphone%20chip%20circuit%20and%20code%20fragments%2C%20warm%20cream%20background%2C%20coral%20and%20sage%20green%20accents%2C%20flat%20editorial%20illustration%2C%20clean%20lines%2C%20soft%20shadows%2C%20friendly%20tech%20vibe&width=1200&height=640&seq=cg-channel-tech&orientation=landscape",
  },
  {
    slug: "life",
    name: "生活态度",
    label: "生活",
    tagline: "围观生活方式",
    description:
      "通勤、饮食、兴趣与城市日常里的讨论热潮，收录打工人与生活家的真实纠结和选择。",
    icon: "ri-heart-line",
    accent: "secondary",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20lifestyle%20editorial%20collage%20with%20bicycle%20coffee%20cup%20and%20city%20street%2C%20warm%20cream%20background%2C%20caramel%20tan%20and%20coral%20tones%2C%20flat%20minimal%20illustration%2C%20soft%20shadows%2C%20relaxed%20comfortable%20atmosphere&width=1200&height=640&seq=cg-channel-life&orientation=landscape",
  },
  {
    slug: "consumer",
    name: "消费观察",
    label: "消费",
    tagline: "围观买买买",
    description:
      "从咖啡到手机、从平替到冲动消费，围观大家在花钱这件事上的真实态度与经验之争。",
    icon: "ri-shopping-bag-3-line",
    accent: "primary",
    image:
      "https://readdy.ai/api/search-image?query=retail%20and%20shopping%20editorial%20collage%20with%20coffee%20cup%20shopping%20bag%20and%20price%20tags%2C%20warm%20cream%20background%2C%20coral%20orange%20and%20warm%20brown%20tones%2C%20flat%20modern%20illustration%2C%20soft%20shadows%2C%20bright%20cheerful%20shopping%20mood&width=1200&height=640&seq=cg-channel-buy&orientation=landscape",
  },
];

export const siteInfo = {
  brand: "全网吃瓜",
  slogan: "不翻评论，直接看群众态度",
  intro:
    "全网吃瓜是一个观点聚合站。我们把热门话题下散落在各平台的网友评论、热议观点与情绪走向汇总整理，帮你用一分钟看懂「大家是怎么看的」。",
  mail: "hello@quanwangchigua.com",
};

export function getChannel(slug: string): Channel | undefined {
  return channels.find((c) => c.slug === slug);
}